module.exports = __webpack_public_path__ + "static/media/aviso-de-privacidad.33bd38b5.pdf";